import { render, staticRenderFns } from "./SendTemplateEmailDialog.vue?vue&type=template&id=481ceb42&scoped=true&"
import script from "./SendTemplateEmailDialog.vue?vue&type=script&lang=ts&"
export * from "./SendTemplateEmailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SendTemplateEmailDialog.vue?vue&type=style&index=0&id=481ceb42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ceb42",
  null
  
)

export default component.exports